import React from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";
import { withStyles } from 'material-ui/styles';
import Button from "material-ui/Button";
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';
import NotificationBar from '../Parts/NotificationBar.jsx'
import Loader from '../Parts/Loader';
import IconButton from 'material-ui/IconButton';
import ArrowDropdown from '../Icons/ArrowDropdown';
import Typography from 'material-ui/Typography'

const styles = () => ({
  container: {
    width: "100%",
    paddingTop: 25,
  },

  table: {
    width: "100%",
  },

  tableCell: {
    fontSize: "15px",
    padding: "30px 56px 30px 10px",
  },

  emptyContainer: {
    padding: '50px',
    background: '#FFFFFF',
    boxSizing: 'border-box',
    width: '100%',
  },

  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    position: 'relative',
    cursor: 'pointer',
  },

  button: {
    border: "1px solid #D8DBDF",
    fontSize: "15px",
    minWidth: "54px",
    color: "#181819",
    padding: "10px 15px",
  },

  nameColumn: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  kana: {
    color: '#71737B',
  },

  rightAlign: {
    float: "right",
  },

  arrow: {
    transform: 'translateX(-100%)',
    position: 'absolute',
    right: '-20px',
    width: 'unset',
    height: 'unset',
    transition: 'transform 1s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)',
  },

  headerCell: {
    paddingRight: 120,
  },

  rowCell: {
    paddingRight: 120,
  }
});

class ChildAccountSetting extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.message && nextProps.message !== '') {
      this.displayNotification(nextProps.message, "success");
    } else if (nextProps.errorMessage && nextProps.errorMessage !== '') {
      this.displayNotification(nextProps.errorMessage, "error");
    } else if (nextProps.shortMessage && nextProps.shortMessage !== '') {
      this.displayNotification(nextProps.shortMessage, "green");
    }
  }

  state = {
    showAccountInfo: false,
    showNotification: false,
    showPlanDialog: false,
    message: '',
    messageType: 'success',
    sortType: '',
    isOrderDesc: false,
  }

  toggleNotification = () => {
    this.setState({ showNotification: !this.state.showNotification });
  };

  displayNotification = (message, type = "success") => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    })
  };

  // ソート順を切り替える
  handleClick = (sortType) => {
    let isOrderDesc = true;
    if (this.state.sortType === sortType) {
      this.setState({
        isOrderDesc: !this.state.isOrderDesc
      })
      isOrderDesc = !this.state.isOrderDesc;
    } else {
      this.setState({
        isOrderDesc: true,
        sortType: sortType
      })
    }
    this.props.getChildUsers({
      sort_type: sortType,
      sort_order: isOrderDesc === false ? 'desc' : 'asc',
    })
  };

  renderNotification = () => {
    return (
      <div style={{ position: 'fixed', zIndex: 1000, top: 10, width: '99%' }}>
        <NotificationBar
          message={this.state.message}
          type={this.state.messageType}
          open={this.state.showNotification}
          onHandleClose={this.toggleNotification}
          autoClose={true}
          style={{
            width: this.state.messageType === "green" ? "fit-content" : '100%',
          }}
        >
        </NotificationBar>
      </div>
    );
  };

  renderRow = (info, i) => {
    const { classes } = this.props;
    // アカウント追加日のみ幅を固定する
    const cellStyle = info.key === 'created_at' ? { width: 130 } : {};

    return (
      <TableCell className={classes.headerCell} style={cellStyle} key={i}>
        <div className={classes.sectionHeader}>
          <Typography
            variant="body2"
            style={{ 'flex': 1, fontWeight: 'bold' }}
            onClick={() => this.handleClick(info.key)}
          >
            {info.title}
          </Typography>
          <IconButton
            className={classes.arrow}
            style={{ transform: this.state.sortType === info.key && this.state.isOrderDesc ? 'translateX(-100%) rotate(180deg)' : 'translateX(-100%) rotate(0deg)' }}
            onClick={() => this.handleClick(info.key)}
          >
            <ArrowDropdown color="#71737B" width={20} height={20} />
          </IconButton>
        </div>
      </TableCell>
    );
  };

  childUserItem() {
    const { classes, childUsers } = this.props;
    const childAcoountInfo = [
      { title: '名前', key: 'kana' },
      { title: 'メールアドレス', key: 'email' },
      { title: 'アカウント追加日', key: 'created_at' },
    ]
    const sliceMinuteDisplayCount = 3;
    return (
      <div className={classes.container}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow className={classes.headerRow}>
              {childAcoountInfo.map((info, i) => (
                this.renderRow(info, i)
              ))}
              <TableCell className={classes.headerCell}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {childUsers && (
              childUsers.map((user) => (
                <TableRow key={user.id}>
                  <TableCell className={classes.rowCell}>
                    <div className={classes.nameColumn}>
                      <div className={classes.name}>
                        {user.name}
                      </div>
                      <div className={classes.kana}>
                        {user.kana}
                      </div>
                    </div>
                  </TableCell>
                  <TableCell className={classes.rowCell}>
                    {user.email}
                  </TableCell>
                  {/* user.created_atの値から末尾の3文字（秒）を取り除いて表示 */}
                  <TableCell className={classes.rowCell}>{user.created_at.slice(0, -sliceMinuteDisplayCount)}</TableCell>
                  <TableCell className={classNames(classes.tableCell, classes.thirdCol)}>
                    <Button
                      color="primary"
                      className={classNames(classes.button, classes.rightAlign)}
                      onClick={() => this.props.goTo(`/setting/child-accounts/${user.id}`, {
                        child_account_id: user.id,
                      })}
                    >
                      詳細
                    </Button>
                  </TableCell>
                </TableRow>
              )))}
          </TableBody>
        </Table>
      </div>
    );
  }

  render() {
    const { classes } = this.props;
    let notification;
    if (this.state.showNotification) {
      notification = this.renderNotification();
    }
    if (this.props.isLoading) {
      return (
        <div className={classes.emptyContainer}>
          <Loader type="color" size="large" />
        </div>
      )
    } else {
      return (
        <div>
          {this.childUserItem()}
          {notification}
        </div>
      );
    }
  }
}

ChildAccountSetting.propTypes = {
  classes: PropTypes.object.isRequired,
  childUsers: PropTypes.array,
  message: PropTypes.string,
  errorMessage: PropTypes.string,
  shortMessage: PropTypes.string,
  isSaving: PropTypes.bool,
  error: PropTypes.object,
  isLoading: PropTypes.bool,
  getChildUsers: PropTypes.func,
  goTo: PropTypes.func,
};

export default withStyles(styles)(ChildAccountSetting);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/ChildAccountSetting.jsx